var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Controls/Select"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4532 9.22566C19.848 8.83089 19.848 8.19085 19.4532 7.79608C19.0585 7.40131 18.4184 7.40131 18.0237 7.79608L10.6518 15.1679L5.97566 10.4917C5.58089 10.097 4.94085 10.097 4.54608 10.4917C4.15131 10.8865 4.15131 11.5265 4.54608 11.9213L9.91479 17.29C9.92195 17.2976 9.92926 17.3052 9.9367 17.3126C10.1342 17.5101 10.393 17.6088 10.6518 17.6087C10.9107 17.6088 11.1695 17.5101 11.367 17.3126C11.3744 17.3052 11.3817 17.2976 11.3889 17.29L19.4532 9.22566Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFill);
export default __webpack_public_path__ + "static/media/check-fill.55e2c0f747387f5d7cd0347069349d42.svg";
export { ForwardRef as ReactComponent };